import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './HomeAbout.css';

const HomeAbout = () => {
  const stats = [
    {
      number: '$25+',
      label: 'Transparent visit fees',
    },
    {
      number: '100%',
      label: 'Telehealth-first care',
    },
    {
      number: '6',
      label: 'Core service lines',
    },
    {
      number: '24/7',
      label: 'Reach out by message',
    },
  ];

  return (
    <section className="home-about" id="about">
      <div className="container">
        <div className="about-content">
          <motion.div
            className="about-image-section"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="image-collage">
              <div className="collage-top">
                <div className="collage-person person-1">
                  <img src="/images/about-new1.jpg" alt="Healthcare professional" className="person-image" />
                </div>
                <div className="collage-person person-2">
                  <img src="/images/about-new2.jpg" alt="Patient-centered care" className="person-image" />
                </div>
                <div className="collage-person person-3">
                  <img src="/images/about-new3.jpg" alt="Telehealth consultation" className="person-image" />
                </div>
              </div>
              <div className="collage-bottom">
                <div className="collage-person person-4">
                  <img src="/images/about-new4.jpg" alt="Wellness and prevention" className="person-image" />
                </div>
                <div className="collage-person person-5">
                  <img src="/images/about-new5.jpg" alt="Supportive medical team" className="person-image" />
                </div>
              </div>

              <div className="collage-overlay">
                <div className="overlay-content">
                  <div className="overlay-number">Tele</div>
                  <div className="overlay-text">Health where you are</div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="about-text-section"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.48, delay: 0.12 }}
          >
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.48, delay: 0.24 }}
            >
              About us
            </motion.h2>

            <motion.h3
              className="about-subtitle"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.48, delay: 0.36 }}
            >
              Open Arms Healthcare Services LLC
            </motion.h3>

            <motion.p
              className="about-description"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.48, delay: 0.48 }}
            >
              We are a dedicated telehealth provider focused on making safe, fast, and affordable care available on your
              schedule. Our mission is to break down traditional barriers so expert support is always within reach—by
              video, phone, or message.
            </motion.p>

            <motion.div
              className="key-differentiators"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.48, delay: 0.6 }}
            >
              <h4>What we focus on</h4>
              <p>
                Chronic condition education, non-emergent sick visits, medication refills when appropriate, lab orders
                with clear interpretation, weight management, and smoking cessation—always with upfront pricing for our
                telehealth services (medications and outside labs billed separately).
              </p>
            </motion.div>

            <motion.div
              className="about-cta"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.48, delay: 0.84 }}
            >
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link to="/about" className="btn btn-primary">
                  Learn more
                </Link>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>

        <motion.div
          className="stats-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.48, delay: 0.1 }}
        >
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                className="stat-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.36, delay: 0.2 + index * 0.06 }}
                whileHover={{
                  y: -5,
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                }}
              >
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeAbout;
